import { api_rendicion } from "@/libs/axios/api";
import { PrimaryButton } from "@/ui/buttons/primary";
import { ChangeEvent, FormEvent, useState } from "react";
import { FormContainer } from "./styles";
import { Data } from "@/types/generics";

type Inputs = {
  email: string;
};
export function RecoverForm() {
  const [inputs, setInputs] = useState<Inputs>({ email: "" });
  const [state, setState] = useState<Data>({
    data: null,
    isLoading: false,
    error: null,
  });

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };

  const onSubmit = async (e: FormEvent) => {
    try {
      e.preventDefault();
      const { data } = await api_rendicion.post("/auth/recover", {
        email: inputs.email,
      });

      console.log(data);
    } catch (e: any) {
      let error: Data["error"] = null;
      if (e.response?.data) error = e.response.data;
      else error = { code: e.code, message: e.message };
      setState({ isLoading: false, data: null, error });
    }
  };

  return (
    <FormContainer>
      <form onSubmit={onSubmit}>
        <input
          name="email"
          type="email"
          onChange={onChange}
          value={inputs.email}
        />
        <PrimaryButton isLoading={state.isLoading}>
          Recuperar contraseña
        </PrimaryButton>
        {state.error ? <p>{state.error.message}</p> : null}
      </form>
    </FormContainer>
  );
}
